import { call, put, takeLatest } from 'redux-saga/effects';

import * as headerActions from './headerActions.js';
import { updateHeaderApiCall } from './headerAPI.js';

function* updateHeaderSaga({ payload }) {
  try {
    const { data } = yield call(updateHeaderApiCall, payload);
    yield put(headerActions.headerUpdateStore(data));
  } catch (error) {
    yield put(headerActions.headerUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* headerWatcher() {
  yield takeLatest(headerActions.headerUpdateRequest.type, updateHeaderSaga);
}
